<template>
  <div
    class="toolbar">
    <div
      class="toolbar__title"
      data-qa="title">
      {{ $t(`${title}`) }}
      <sChip
        v-if="filtred_count"
        class="toolbar__count"
        data-qa="items_count"
        :text="filtred_count"/>
      <slot name="filtered_items"/>
    </div>
    <div class="spacer"/>
    <slot name="filter"/>
  </div>
</template>
<script>
export default {
  name: 'menuComponentToolbar',
  props: {
    custom_title: String,
    filtred_count: [Number, String, Boolean],
  },
  computed: {
    title() {
      return this.custom_title || this.$route.meta.caption
    },
  },
}
</script>
<style lang="scss" scoped>
.toolbar {
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding-top: 24px;
  background-color: var(--v-main__green-base) !important;
  z-index: 5;
  .is-border {
    padding-bottom: 8px;
    border-bottom: 1px solid var(--v-main__light_green-base);
  }
  &__title {
    text-align: start;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    display: flex;
    white-space: nowrap;
  }
  &__count {
    font-weight: 500;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.02em;
    margin: 12px 0 auto 5px;
  }
  .search {
    max-width: 70px;
    max-height: 36px;
    height: 36px;
    &.v-input--is-focused {
      max-width: 300px
    }
  }
}

.filters-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  img {
    height: 16px;
    width: 16px;;
  }
  &.open {
    opacity: 0.5;
    &::before {
      background: none;
    }
  }
}

.cancel-btn {
  height: 30px;
  width: 30px;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 0;
}

</style>
<style lang="scss">
.toolbar.filters .search {
  .v-input__control > .v-input__slot{
    padding: 0 !important;
    input::placeholder {
      color: var(--black-color);
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }
    &:before {
      border: none;
    }
  }
}

</style>
